import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GuestRegValidateOTPUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    async fetchResult(req) {
        return await this.loginFLowRepo.guestRegValidateOTP(req);
    }
}
export default GuestRegValidateOTPUseCase;
